module.exports = __webpack_public_path__ + "static/media/030.cfefd991.jpg";